<template lang="pug">
    .wrapper
        .titulo(v-if="titulo") {{ titulo }}
        .selecao(v-click-outside="voltarParaSelecaoAnterior")
            .selecao-container
              .filtro(v-show="filtroHabilitado && permiteFiltro" @click="manterOpcoesAbertas")
                  input(type="text" v-model.trim="parametroBusca" ref="busca")
                  .icone-chapado-seta-baixo(:class="mostraOpcoes ? 'opcoesAbertas' : ''")
              .selecionado(v-show="!filtroHabilitado" @click="abrirOpcoes")
                  span {{ opcaoSelecionada[opcaoRef] || $t('comum.seletores.pSelect.placeholder') }}
                  .icone-chapado-seta-baixo(:class="mostraOpcoes ? 'opcoesAbertas' : ''")
            .opcoes(v-show="mostraOpcoes" ref="opcoes")
                .opcao(
                    :class="opcao.id === opcaoSelecionada.id ? 'selecionada' : ''"
                    v-for="opcao in opcoes"
                    :key="opcao.id || opcao"
                    @click="selecionarOpcao(opcao)"
                    )
                    span {{opcao[opcaoRef]}}
                    .icone-chapado-certo(v-if="opcao.id === opcaoSelecionada.id")
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
  name: 'PSelect',
  props: {
    titulo: {type: String, required: false, default: ''},
    permiteFiltro: {type: Boolean, required: false, default: false},
    opcoes: {type: Array, required: false},
    opcaoPadrao: {type: Object, required: false}, // É Importante que que cada item possua o seu ID.
    opcaoRef: {type: String, required: false},
    faltaItems: {type: Boolean, required: false, default: false}
  },
  data () {
    return {
      filtroHabilitado: false,
      parametroBusca: null,
      mostraOpcoes: false,
      opcaoSelecionada: {}
    }
  },
  created () {
    this.verificarSeExisteOpcaoPadrao()
  },
  mounted () {
    this.$refs.opcoes.addEventListener('scroll', e => {
      const opcoes = e.target
      const fimDoScroll = opcoes.scrollHeight - opcoes.scrollTop === opcoes.clientHeight

      if (fimDoScroll) {
        if (this.$props.faltaItems) {
          this.$emit('buscarMaisItems')
        }
      }
    })
  },
  methods: {
    verificarSeExisteOpcaoPadrao () {
      const opcaoPadrao = this.$props.opcaoPadrao
      this.opcaoSelecionada = opcaoPadrao || {}
    },
    abrirOpcoes () {
      this.mostraOpcoes = !this.mostraOpcoes
      this.filtroHabilitado = true
      this.$nextTick(() => (this.$refs.busca.focus()))
    },
    manterOpcoesAbertas () {
      this.mostraOpcoes = true
    },
    selecionarOpcao (opcao) {
      this.opcaoSelecionada = opcao
      this.mostraOpcoes = false
      this.filtroHabilitado = false
      this.parametroBusca = ''
    },
    voltarParaSelecaoAnterior () {
      this.selecionarOpcao(this.opcaoSelecionada)
    }
  },
  watch: {
    opcaoSelecionada (currentValue) {
      this.$emit('opcaoSelecionada', currentValue)
    },
    parametroBusca (currentValue) {
      if (currentValue) {
        this.mostraOpcoes = true
      }
      this.$emit('parametroBusca', currentValue)
    }
  },
  directives: {
    ClickOutside
  }
}
</script>
<style scoped>
.wrapper {
    width: 100%;
}
.titulo {
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.selecao {
    position: relative;
    width: 100%;
    min-height: 50px;
    background-color: #fff;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
}
.selecao-container {
  display: flex;
  align-items: center;
  min-height: inherit;
  cursor: pointer;
  width: 100%;
}
.selecionado,
.filtro {
    min-height: inherit;
    padding: 0 0.375rem;
    flex: 1;
    display: flex;
    align-items: center;
}
.selecionado span,
.filtro input {
    flex: 1
}
.filtro input {
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none;
}
.selecionado .icone-chapado-seta-baixo.opcoesAbertas {
    transform: rotate(180deg);
}

.opcoes {
    z-index: 99;
    position: absolute;
    min-height: 53px;
    max-height: 140px;
    overflow-y: scroll;
    top: 55px;
    left: 0px;
    right: 0px;
    background-color: #fff;
    border: 1px solid #ccc;

    display: flex;
    flex-direction: column;
}
.opcoes  .opcao {
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    padding: 0 0.375rem;
    min-height: 35px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.opcoes  .opcao.selecionada {
    background-color: var(--color-success-hover);
    color: var(--color-default-hover)
}
.opcoes  .opcao span {
    flex: 1
}
.opcoes  .opcao .icone-chapado-certo {
    color: var(--color-default-hover);
}
.opcoes  .opcao:hover {
    background-color: var(--color-success-hover);
    color: var(--color-default-hover)
}
</style>
